export const DELETE_CART = 'DELETE_CART';
export const UPDATE_CART = 'UPDATE_CART';
export const CHECK_COMBINATION = 'CHECK_COMBINATION';
export const UPSELL_CART = 'UPSELL_CART';

export const ACTION = {
    DELETE_CART,
    UPDATE_CART,
    CHECK_COMBINATION,
    UPSELL_CART
};


// WEBPACK FOOTER //
// ./resources/assets/js/front/cart/store/action-types.js